import { render, staticRenderFns } from "./TabsMenuDetailsDossier.vue?vue&type=template&id=ab1e885e&"
import script from "./TabsMenuDetailsDossier.vue?vue&type=script&lang=ts&"
export * from "./TabsMenuDetailsDossier.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports